module.exports = __webpack_public_path__ + "img/card_left_decoration.d70f96d9.png";